export default __webpack_public_path__ + "static/media/mail.9ecf8b67.svg";